import { render, staticRenderFns } from "./LpProdOption.vue?vue&type=template&id=5682a584&scoped=true"
import script from "./LpProdOption.vue?vue&type=script&lang=js"
export * from "./LpProdOption.vue?vue&type=script&lang=js"
import style0 from "./LpProdOption.vue?vue&type=style&index=0&id=5682a584&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682a584",
  null
  
)

export default component.exports